style= require('./events.styl')
.events
  - var sport = match.sport 
  - var cleanSheetCreated = false
  if whitelists[sport]
    ft-button(
      warning,
      (click)=this.toggleWhitelist()
    )=this.useWhitelist ? 'See all events' : 'Hide events'
  each item, index in mainEvents
    - var event = item.event
    if event.name === 'clean_sheet'
      if !cleanSheetCreated
        - cleanSheetCreated = true
        .event-wrapper(
          data-index=index,
          data-event=event,
          class=item.state,
        )
          .controls
            ft-icon.clock(name="ui--clock")
            .match-event
              = prettyName(event)
          .confirm-actions
            ft-icon.edit(
              (click)=this.toggleCleanSheet(),
              name=this.cleanSheetExpanded ? "ui--expand" : "ui--collapse"
            )
      if this.cleanSheetExpanded
        - return
    .event-wrapper(
      data-index=index,
      data-event=event,
      class=item.state,
      class={ protected: event.validity === 'protected',
      confirmed: event.validity === 'confirmed'}
    )
      if isVisible(index)
        if event.side === 'match' && context !== 'confirmations'
          .controls
            ft-icon.clock(name="ui--clock")
            .match-event
              = prettyName(event)
              if event.player
                ft-tooltip.player(text=event.player.fullName)
                  a= event.player.name
            ft-icon.cross(
              (click)=this.destroy(item.event),
              name="ui--cross"
            )
          .confirm-actions
            if event.validity === 'confirmed'
              ft-icon.edit(
                (click)=this.unconfirm(item.event),
                name="ui--arrow_right"
              )
            else
              .detail
                ='Click to confirm'
              ft-icon.edit(
                (click)=this.confirm(item.event),
                name="ui--arrow_left"
              )
        else
          .filler(class=otherSide(event))
          if showMinute
            if translateMinute
              .minute= translatedMinute(event)
            else
              .minute= event.counter
          .controls(class=event.side)
            .delete-actions
              if validity && (context !== 'confirmations')
                if event.validity === 'invalid'
                  ft-icon.delete(
                    (click)=this.validate(item.event),
                    name="ui--success"
                  )
                else if event.validity == 'valid'
                  ft-icon.edit.trash(
                    (click)=this.invalidate(item.event),
                    name="ui--trash"
                  )
                else if event.validity === 'protected'
                    ft-icon.edit.trash(
                      (click)=this.destroy(item.event),
                      name="ui--trash"
                    )
                    ft-icon.lock(name="ui--security")
              else if context !== 'confirmations'
                ft-icon.delete(
                  (click)=this.destroy(item.event),
                  name="ui--cross"
                )
            .confirm-actions
              if event.validity === 'confirmed'
                ft-icon.edit(
                  (click)=this.unconfirm(item.event),
                  name="ui--arrow_right"
                )
              else
                .detail
                  ='Click to confirm'
                ft-icon.edit(
                  (click)=this.confirm(item.event),
                  name="ui--arrow_left"
                )
            .edit-actions
              if item.state !== 'added'
                if context !== 'confirmations'
                  ft-icon.edit(
                    name="ui--edit",
                    (click)=this.edit(item.event)
                  )
              .details(class=event.validity)
                .detail
                  if event.player
                    ft-tooltip.player(text=event.player.fullName)
                      a= event.player.name
                  else
                    .player
                  if event.name
                    .name(class=[event.name])= prettyName(event)
                  ft-icon.default-col.icon(no-warning=true, name=event.icon)
                each ev in subEvents(event)
                  .detail
                    if ev.player
                      ft-tooltip.player(text=ev.player.fullName)
                        a= ev.player.name
                    if ev.name
                      .name= prettyName(ev)
                    ft-icon.default-col.icon(no-warning=true, name=ev.icon)
              if event.duration
                .duration= prettyDuration(event)
